// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.docx-viewer {
  padding: 0 16px;
  /* Begin bidirectionality settings (do not change) */
}
.docx-viewer html,
.docx-viewer bodyaddress,
.docx-viewer blockquote,
.docx-viewer body,
.docx-viewer dd,
.docx-viewer div,
.docx-viewer dl,
.docx-viewer dt,
.docx-viewer fieldset,
.docx-viewer form,
.docx-viewer frame,
.docx-viewer frameset,
.docx-viewer h1,
.docx-viewer h2,
.docx-viewer h3,
.docx-viewer h4,
.docx-viewer h5,
.docx-viewer h6,
.docx-viewer noframes,
.docx-viewer ol,
.docx-viewer p,
.docx-viewer ul,
.docx-viewer center,
.docx-viewer dir,
.docx-viewer hr,
.docx-viewer menu,
.docx-viewer pre {
  display: block;
  unicode-bidi: embed;
}
.docx-viewer li {
  display: list-item;
  list-style-type: disc;
}
.docx-viewer head {
  display: none;
}
.docx-viewer table {
  display: table;
}
.docx-viewer img {
  max-width: 100%;
}
.docx-viewer tr {
  display: table-row;
}
.docx-viewer thead {
  display: table-header-group;
}
.docx-viewer tbody {
  display: table-row-group;
}
.docx-viewer tfoot {
  display: table-footer-group;
}
.docx-viewer col {
  display: table-column;
}
.docx-viewer colgroup {
  display: table-column-group;
}
.docx-viewer th {
  display: table-cell;
}
.docx-viewer td {
  display: table-cell;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 0.2em 0.5em;
}
.docx-viewer caption {
  display: table-caption;
}
.docx-viewer th {
  font-weight: bolder;
  text-align: center;
}
.docx-viewer caption {
  text-align: center;
}
.docx-viewer body {
  margin: 8px;
}
.docx-viewer h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
.docx-viewer h2 {
  font-size: 1.5em;
  margin: 0.75em 0;
}
.docx-viewer h3 {
  font-size: 1.17em;
  margin: 0.83em 0;
}
.docx-viewer h4,
.docx-viewer p,
.docx-viewer blockquote,
.docx-viewer ul,
.docx-viewer fieldset,
.docx-viewer form,
.docx-viewer ol,
.docx-viewer dl,
.docx-viewer dir,
.docx-viewer menu {
  margin: 1.12em 0;
}
.docx-viewer h5 {
  font-size: 0.83em;
  margin: 1.5em 0;
}
.docx-viewer h6 {
  font-size: 0.75em;
  margin: 1.67em 0;
}
.docx-viewer h1,
.docx-viewer h2,
.docx-viewer h3,
.docx-viewer h4,
.docx-viewer h5,
.docx-viewer h6,
.docx-viewer b,
.docx-viewer strong {
  font-weight: bolder;
}
.docx-viewer blockquote {
  margin-left: 40px;
  margin-right: 40px;
}
.docx-viewer i,
.docx-viewer cite,
.docx-viewer em,
.docx-viewer var,
.docx-viewer address {
  font-style: italic;
}
.docx-viewer pre,
.docx-viewer tt,
.docx-viewer code,
.docx-viewer kbd,
.docx-viewer samp {
  font-family: monospace;
}
.docx-viewer pre {
  white-space: pre;
}
.docx-viewer button,
.docx-viewer textarea,
.docx-viewer input,
.docx-viewer select {
  display: inline-block;
}
.docx-viewer big {
  font-size: 1.17em;
}
.docx-viewer small,
.docx-viewer sub,
.docx-viewer sup {
  font-size: 0.83em;
}
.docx-viewer sub {
  vertical-align: sub;
}
.docx-viewer sup {
  vertical-align: super;
}
.docx-viewer table {
  border-spacing: 2px;
}
.docx-viewer thead,
.docx-viewer tbody,
.docx-viewer tfoot {
  vertical-align: middle;
}
.docx-viewer td,
.docx-viewer th,
.docx-viewer tr {
  vertical-align: inherit;
}
.docx-viewer s,
.docx-viewer strike,
.docx-viewer del {
  text-decoration: line-through;
}
.docx-viewer hr {
  border: 1px inset;
}
.docx-viewer ol,
.docx-viewer ul,
.docx-viewer dir,
.docx-viewer menu,
.docx-viewer dd {
  margin-left: 40px;
}
.docx-viewer ol {
  list-style-type: decimal;
}
.docx-viewer ol ul,
.docx-viewer ol ul,
.docx-viewer ul ol,
.docx-viewer ul ol,
.docx-viewer ul ul,
.docx-viewer ul ul,
.docx-viewer ol ol,
.docx-viewer ol ol {
  margin-top: 0;
  margin-bottom: 0;
}
.docx-viewer u,
.docx-viewer ins {
  text-decoration: underline;
}
.docx-viewer br:before {
  content: '\\A';
  white-space: pre-line;
}
.docx-viewer center {
  text-align: center;
}
.docx-viewer :link,
.docx-viewer :visited {
  text-decoration: underline;
}
.docx-viewer :focus {
  outline: thin dotted invert;
}
.docx-viewer BDO[DIR='ltr'] {
  direction: ltr;
  unicode-bidi: bidi-override;
}
.docx-viewer BDO[DIR='rtl'] {
  direction: rtl;
  unicode-bidi: bidi-override;
}
.docx-viewer *[DIR='ltr'] {
  direction: ltr;
  unicode-bidi: embed;
}
.docx-viewer *[DIR='rtl'] {
  direction: rtl;
  unicode-bidi: embed;
}
@media print {
  .docx-viewer h1 {
    page-break-before: always;
  }
  .docx-viewer h1,
  .docx-viewer h2,
  .docx-viewer h3,
  .docx-viewer h4,
  .docx-viewer h5,
  .docx-viewer h6 {
    page-break-after: avoid;
  }
  .docx-viewer ul,
  .docx-viewer ol,
  .docx-viewer dl {
    page-break-before: avoid;
  }
}
.docx-viewer .docx-wrapper {
  padding: 0;
}
.docx-viewer .docx-wrapper .docx {
  width: 100% !important;
  box-shadow: none !important;
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/DocxViewer/DocxViewer.less"],"names":[],"mappings":"AAEA;EACE,eAAA;EADA,oDAAoD;AACtD;AADA;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BI,cAAA;EACA,mBAAA;AADJ;AA/BA;EAmCI,kBAAA;EACA,qBAAA;AADJ;AAnCA;EAuCI,aAAA;AADJ;AAtCA;EA0CI,cAAA;AADJ;AAzCA;EA6CI,eAAA;AADJ;AA5CA;EAgDI,kBAAA;AADJ;AA/CA;EAmDI,2BAAA;AADJ;AAlDA;EAsDI,wBAAA;AADJ;AArDA;EAyDI,2BAAA;AADJ;AAxDA;EA4DI,qBAAA;AADJ;AA3DA;EA+DI,2BAAA;AADJ;AA9DA;EAkEI,mBAAA;AADJ;AAjEA;EAqEI,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,oBAAA;AADJ;AAvEA;EA2EI,sBAAA;AADJ;AA1EA;EA8EI,mBAAA;EACA,kBAAA;AADJ;AA9EA;EAkFI,kBAAA;AADJ;AAjFA;EAqFI,WAAA;AADJ;AApFA;EAwFI,cAAA;EACA,gBAAA;AADJ;AAxFA;EA4FI,gBAAA;EACA,gBAAA;AADJ;AA5FA;EAgGI,iBAAA;EACA,gBAAA;AADJ;AAhGA;;;;;;;;;;EA6GI,gBAAA;AADJ;AA5GA;EAgHI,iBAAA;EACA,eAAA;AADJ;AAhHA;EAoHI,iBAAA;EACA,gBAAA;AADJ;AApHA;;;;;;;;EA+HI,mBAAA;AADJ;AA9HA;EAkII,iBAAA;EACA,kBAAA;AADJ;AAlIA;;;;;EA0II,kBAAA;AADJ;AAzIA;;;;;EAiJI,sBAAA;AADJ;AAhJA;EAoJI,gBAAA;AADJ;AAnJA;;;;EA0JI,qBAAA;AADJ;AAzJA;EA6JI,iBAAA;AADJ;AA5JA;;;EAkKI,iBAAA;AADJ;AAjKA;EAqKI,mBAAA;AADJ;AApKA;EAwKI,qBAAA;AADJ;AAvKA;EA2KI,mBAAA;AADJ;AA1KA;;;EAgLI,sBAAA;AADJ;AA/KA;;;EAqLI,uBAAA;AADJ;AApLA;;;EA0LI,6BAAA;AADJ;AAzLA;EA6LI,iBAAA;AADJ;AA5LA;;;;;EAoMI,iBAAA;AADJ;AAnMA;EAuMI,wBAAA;AADJ;AAtMA;;;;;;;;EAiNI,aAAA;EACA,gBAAA;AADJ;AAjNA;;EAsNI,0BAAA;AADJ;AArNA;EAyNI,aAAA;EACA,qBAAA;AADJ;AAzNA;EA6NI,kBAAA;AADJ;AA5NA;;EAiOI,0BAAA;AADJ;AAhOA;EAoOI,2BAAA;AADJ;AAnOA;EAwOI,cAAA;EACA,2BAAA;AAFJ;AAvOA;EA4OI,cAAA;EACA,2BAAA;AAFJ;AA3OA;EAgPI,cAAA;EACA,mBAAA;AAFJ;AA/OA;EAoPI,cAAA;EACA,mBAAA;AAFJ;AAIE;EAAA;IAEI,yBAAA;EAFJ;EAAA;;;;;;IAUI,uBAAA;EAFJ;EARA;;;IAeI,wBAAA;EAFJ;AACF;AAOE;EACE,UAAA;AALJ;AAMI;EACE,sBAAA;EACA,2BAAA;EACA,qBAAA;AAJN","sourcesContent":["@import '@css/variables.less';\n\n.docx-viewer {\n  padding: 0 16px;\n\n  // Doc viewer's CSS presets from https://github.com/plangrid/react-file-viewer/blob/master/src/styles/docx.scss\n  html,\n  bodyaddress,\n  blockquote,\n  body,\n  dd,\n  div,\n  dl,\n  dt,\n  fieldset,\n  form,\n  frame,\n  frameset,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  noframes,\n  ol,\n  p,\n  ul,\n  center,\n  dir,\n  hr,\n  menu,\n  pre {\n    display: block;\n    unicode-bidi: embed;\n  }\n  li {\n    display: list-item;\n    list-style-type: disc;\n  }\n  head {\n    display: none;\n  }\n  table {\n    display: table;\n  }\n  img {\n    max-width: 100%;\n  }\n  tr {\n    display: table-row;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tbody {\n    display: table-row-group;\n  }\n  tfoot {\n    display: table-footer-group;\n  }\n  col {\n    display: table-column;\n  }\n  colgroup {\n    display: table-column-group;\n  }\n  th {\n    display: table-cell;\n  }\n  td {\n    display: table-cell;\n    border-bottom: 1px solid #ccc;\n    border-right: 1px solid #ccc;\n    padding: 0.2em 0.5em;\n  }\n  caption {\n    display: table-caption;\n  }\n  th {\n    font-weight: bolder;\n    text-align: center;\n  }\n  caption {\n    text-align: center;\n  }\n  body {\n    margin: 8px;\n  }\n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n  h2 {\n    font-size: 1.5em;\n    margin: 0.75em 0;\n  }\n  h3 {\n    font-size: 1.17em;\n    margin: 0.83em 0;\n  }\n  h4,\n  p,\n  blockquote,\n  ul,\n  fieldset,\n  form,\n  ol,\n  dl,\n  dir,\n  menu {\n    margin: 1.12em 0;\n  }\n  h5 {\n    font-size: 0.83em;\n    margin: 1.5em 0;\n  }\n  h6 {\n    font-size: 0.75em;\n    margin: 1.67em 0;\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  b,\n  strong {\n    font-weight: bolder;\n  }\n  blockquote {\n    margin-left: 40px;\n    margin-right: 40px;\n  }\n  i,\n  cite,\n  em,\n  var,\n  address {\n    font-style: italic;\n  }\n  pre,\n  tt,\n  code,\n  kbd,\n  samp {\n    font-family: monospace;\n  }\n  pre {\n    white-space: pre;\n  }\n  button,\n  textarea,\n  input,\n  select {\n    display: inline-block;\n  }\n  big {\n    font-size: 1.17em;\n  }\n  small,\n  sub,\n  sup {\n    font-size: 0.83em;\n  }\n  sub {\n    vertical-align: sub;\n  }\n  sup {\n    vertical-align: super;\n  }\n  table {\n    border-spacing: 2px;\n  }\n  thead,\n  tbody,\n  tfoot {\n    vertical-align: middle;\n  }\n  td,\n  th,\n  tr {\n    vertical-align: inherit;\n  }\n  s,\n  strike,\n  del {\n    text-decoration: line-through;\n  }\n  hr {\n    border: 1px inset;\n  }\n  ol,\n  ul,\n  dir,\n  menu,\n  dd {\n    margin-left: 40px;\n  }\n  ol {\n    list-style-type: decimal;\n  }\n  ol ul,\n  ol ul,\n  ul ol,\n  ul ol,\n  ul ul,\n  ul ul,\n  ol ol,\n  ol ol {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  u,\n  ins {\n    text-decoration: underline;\n  }\n  br:before {\n    content: '\\A';\n    white-space: pre-line;\n  }\n  center {\n    text-align: center;\n  }\n  :link,\n  :visited {\n    text-decoration: underline;\n  }\n  :focus {\n    outline: thin dotted invert;\n  }\n  /* Begin bidirectionality settings (do not change) */\n  BDO[DIR='ltr'] {\n    direction: ltr;\n    unicode-bidi: bidi-override;\n  }\n  BDO[DIR='rtl'] {\n    direction: rtl;\n    unicode-bidi: bidi-override;\n  }\n  *[DIR='ltr'] {\n    direction: ltr;\n    unicode-bidi: embed;\n  }\n  *[DIR='rtl'] {\n    direction: rtl;\n    unicode-bidi: embed;\n  }\n  @media print {\n    h1 {\n      page-break-before: always;\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      page-break-after: avoid;\n    }\n    ul,\n    ol,\n    dl {\n      page-break-before: avoid;\n    }\n  }\n}\n\n.docx-viewer {\n  & .docx-wrapper {\n    padding: 0;\n    & .docx {\n      width: 100% !important;\n      box-shadow: none !important;\n      padding: 0 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
